"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLevelPercentage = exports.predictExhaustSync = exports.predictExhaust = exports.isNearlyDepleted = exports.isDepleted = exports.isDepletable = void 0;
const effect_1 = require("effect");
const definition_1 = require("../../capability/consumable/definition");
const Common = __importStar(require("./common"));
const isDepletable = (consumable) => consumable.subset instanceof definition_1.Depletable;
exports.isDepletable = isDepletable;
const isDepleted = (consumable) => consumable.state.level <= consumable.subset.rangeExhaust.amount;
exports.isDepleted = isDepleted;
const isNearlyDepleted = (consumable) => !(0, exports.isDepleted)(consumable) && consumable.state.level <= consumable.subset.rangeTrigger.amount;
exports.isNearlyDepleted = isNearlyDepleted;
/**
 * Predict the {@link DateTime.DateTime DateTime} the depletable consumable is expected to reach the `rangeExhaust`,
 * assuming the current rate of depletion is maintained.
 */
exports.predictExhaust = effect_1.Effect.fn('predictExhaust')(function* (consumable) {
    if (consumable.state.level === consumable.subset.rangeFullCapacity.amount)
        yield* effect_1.Effect.fail(new Common.ExhaustUnpredictableError({ cause: consumable, reason: 'Unused' }));
    const installedAt = yield* effect_1.Schema.decode(effect_1.Schema.DateTimeUtcFromDate)(consumable.state.installedAt);
    const age = effect_1.DateTime.distanceDuration(yield* effect_1.DateTime.now, installedAt);
    const usage = consumable.subset.rangeFullCapacity.amount - consumable.state.level;
    const spentFraction = usage / consumable.subset.rangeFullCapacity.amount;
    const maxAge = effect_1.Duration.times(age, 1 / spentFraction);
    return effect_1.DateTime.addDuration(installedAt, maxAge);
});
/**
 * See {@link predictExhaust}
 */
const predictExhaustSync = (...args) => effect_1.Effect.runSync((0, exports.predictExhaust)(...args));
exports.predictExhaustSync = predictExhaustSync;
/**
 * Returns a number representing the percentual `level` of the consumable, measured against its `rangeFullCapacity`.
 * Returns `0` for a virgin consumable, returns `1` for a consumable that has reached its `rangeExhaust`.
 */
const getLevelPercentage = ({ subset: { rangeFullCapacity, rangeExhaust }, state: { level }, }) => 1 - level / (rangeFullCapacity.amount - rangeExhaust.amount);
exports.getLevelPercentage = getLevelPercentage;
//# sourceMappingURL=depletable.js.map